import React, { useEffect, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { bool } from 'prop-types';

import { SDPContext } from 'Contexts';
import { UPDATE_CURRENT_COMPANY } from 'Contexts/SDP';
import { notify } from 'Utils';

import { Selector } from 'Components';

import { ManagerIcon } from 'Assets/icons';

export default function SelectCompany({ iconOnly }) {
  const history = useHistory();
  const {
    state: {
      company: {
        data: { all: allCompanies, current: currentCompany }
      }
    },
    dispatch
  } = useContext(SDPContext);
  const [companyList, setCompanyList] = useState([]);

  useEffect(() => {
    if (allCompanies?.length) {
      const accounts = allCompanies?.map((el) => ({
        name: el.name,
        icon: <ManagerIcon />,
        value: el.id
      }));

      setCompanyList(accounts);
    }
  }, [allCompanies]);

  function handleChangeCurrentCompany(id) {
    if (currentCompany?.id === id) return;
    const newCurr = allCompanies.filter((el) => el.id === id).shift();
    dispatch({ type: UPDATE_CURRENT_COMPANY, payload: newCurr });
    notify({
      message: `Successfully switched to company ${newCurr?.name}`
    });
    history.push('/');
  }

  return (
    <Selector
      headerText="switch account to..."
      elements={companyList}
      current={companyList
        .filter((el) => el?.value === currentCompany?.id)
        .shift()}
      iconOnly={iconOnly}
      alignment="left"
      onSelect={(e) => handleChangeCurrentCompany(e?.value)}
    />
  );
}

SelectCompany.propTypes = {
  iconOnly: bool
};

SelectCompany.defaultProps = {
  iconOnly: false
};
